import {requests} from "../../helpers/api.services";
import {DRIVER_REGISTRATION_SETTINGS_URL} from "../../helpers/api.routes";

export const AdminDriverRegistrationSettingsService = {
    get: () => requests.get(DRIVER_REGISTRATION_SETTINGS_URL),
    create: (params: any) => requests.post(DRIVER_REGISTRATION_SETTINGS_URL, params)
}